import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const UploadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default UploadSVG;
